import { TopicsCategory } from '../topics/TopicsCategory';

export const WebCategory = {
  // 主要
  MAJOR: 'major',
  TOP_PICKS: 'top-picks',
  // 国内
  DOMESTIC: 'domestic',
  // 国際
  WORLD: 'world',
  // 経済
  BUSINESS: 'business',
  // エンタメ
  ENTERTAINMENT: 'entertainment',
  // スポーツ
  SPORTS: 'sports',
  // IT
  IT: 'it',
  // 科学
  SCIENCE: 'science',
  // ライフ
  LIFE: 'life',
  // 地域
  LOCAL: 'local'
} as const;

export type WebCategory = (typeof WebCategory)[keyof typeof WebCategory];

/**
 * トピックスのカテゴリに紐づくWebのカテゴリを返す
 *
 * トピックスに存在しないcategoryを渡された場合は、undefinedを返す
 *
 * @param category
 */
export function fromTopicsCategory(category: TopicsCategory): WebCategory {
  switch (category) {
    case TopicsCategory.MAJOR:
      return WebCategory.MAJOR;
    case TopicsCategory.DOMESTIC:
      return WebCategory.DOMESTIC;
    case TopicsCategory.WORLD:
      return WebCategory.WORLD;
    case TopicsCategory.ECONOMY:
      return WebCategory.BUSINESS;
    case TopicsCategory.ENTERTAINMENT:
      return WebCategory.ENTERTAINMENT;
    case TopicsCategory.SPORTS:
      return WebCategory.SPORTS;
    case TopicsCategory.COMPUTER:
      return WebCategory.IT;
    case TopicsCategory.SCIENCE:
      return WebCategory.SCIENCE;
    case TopicsCategory.LOCAL:
      return WebCategory.LOCAL;
  }
}
/**
 * stringをWebCategoryに変換する
 * 存在しないcategoryを渡された場合は、undefinedを返す
 *
 * @param category
 */
export function fromString(category: string | undefined): WebCategory | undefined {
  switch (category) {
    case WebCategory.MAJOR:
      return WebCategory.MAJOR;
    case WebCategory.TOP_PICKS:
      return WebCategory.TOP_PICKS;
    case WebCategory.DOMESTIC:
      return WebCategory.DOMESTIC;
    case WebCategory.WORLD:
      return WebCategory.WORLD;
    case WebCategory.BUSINESS:
      return WebCategory.BUSINESS;
    case WebCategory.ENTERTAINMENT:
      return WebCategory.ENTERTAINMENT;
    case WebCategory.SPORTS:
      return WebCategory.SPORTS;
    case WebCategory.IT:
      return WebCategory.IT;
    case WebCategory.SCIENCE:
      return WebCategory.SCIENCE;
    case WebCategory.LIFE:
      return WebCategory.LIFE;
    case WebCategory.LOCAL:
      return WebCategory.LOCAL;
  }
  return undefined;
}

/**
 * Webのカテゴリに紐づくトップリンクを返す
 *
 * 存在しないcategoryを渡された場合は、undefinedを返す
 *
 * @param category
 */
export function convertTopLink(category: WebCategory): string | undefined {
  switch (category) {
    case WebCategory.MAJOR:
      return '/';
    case WebCategory.DOMESTIC:
      return '/categories/domestic';
    case WebCategory.WORLD:
      return '/categories/world';
    case WebCategory.BUSINESS:
      return '/categories/business';
    case WebCategory.ENTERTAINMENT:
      return '/categories/entertainment';
    case WebCategory.SPORTS:
      return '/categories/sports';
    case WebCategory.IT:
      return '/categories/it';
    case WebCategory.SCIENCE:
      return '/categories/science';
    case WebCategory.LOCAL:
      return '/categories/local';
    case WebCategory.LIFE:
      return '/categories/life';
  }
  return undefined;
}

/**
 * Webのカテゴリに紐づくもっと見るリンクを返す
 *
 * 存在しないcategoryを渡された場合は、undefinedを返す
 *
 * @param category
 */
export function toTopicsListLink(category: WebCategory): string | undefined {
  switch (category) {
    case WebCategory.TOP_PICKS:
    case WebCategory.MAJOR:
      return '/topics/top-picks';
    case WebCategory.DOMESTIC:
      return '/topics/domestic';
    case WebCategory.WORLD:
      return '/topics/world';
    case WebCategory.BUSINESS:
      return '/topics/business';
    case WebCategory.ENTERTAINMENT:
      return '/topics/entertainment';
    case WebCategory.SPORTS:
      return '/topics/sports';
    case WebCategory.IT:
      return '/topics/it';
    case WebCategory.SCIENCE:
      return '/topics/science';
    case WebCategory.LOCAL:
      return '/topics/local';
  }
  return undefined;
}

/**
 * Webのカテゴリに紐づく日本語名を返す
 *
 * 存在しないcategoryを渡された場合は、undefinedを返す
 *
 * @param category
 */
export function convertToJapanese(category: WebCategory): string | undefined {
  switch (category) {
    case WebCategory.MAJOR:
    case WebCategory.TOP_PICKS:
      return '主要';
    case WebCategory.DOMESTIC:
      return '国内';
    case WebCategory.WORLD:
      return '国際';
    case WebCategory.BUSINESS:
      return '経済';
    case WebCategory.ENTERTAINMENT:
      return 'エンタメ';
    case WebCategory.SPORTS:
      return 'スポーツ';
    case WebCategory.IT:
      return 'IT';
    case WebCategory.SCIENCE:
      return '科学';
    case WebCategory.LIFE:
      return 'ライフ';
    case WebCategory.LOCAL:
      return '地域';
  }
  return undefined;
}

/**
 * Webのカテゴリを短縮表記にする
 *
 * @param category
 */
export function convertShortName(category: WebCategory): string {
  switch (category) {
    case WebCategory.MAJOR:
    case WebCategory.TOP_PICKS:
      return 'toppicks';
    case WebCategory.DOMESTIC:
      return 'dom';
    case WebCategory.WORLD:
      return 'wor';
    case WebCategory.BUSINESS:
      return 'bus';
    case WebCategory.ENTERTAINMENT:
      return 'ent';
    case WebCategory.SPORTS:
      return 'spo';
    case WebCategory.IT:
      return 'it';
    case WebCategory.SCIENCE:
      return 'sci';
    case WebCategory.LIFE:
      return 'lif';
    case WebCategory.LOCAL:
      return 'loc';
  }
}
